import { Button, IdentifierText, TextWrapper } from './ControllerIdItem.styles';
import { Fragment, FunctionalComponent, h } from 'preact';
import { Section, Title } from '../List';
import { CopyIcon } from '../../assets';
import { VerticalSpacer } from '../Spacers/VerticalSpacer';
import { memo } from 'preact/compat';
import { useSettingsContext } from '../../contexts/SettingsContext';

type props = {
  label: string;
};

const ControllerIdItem: FunctionalComponent<props> = memo(({ label }) => {
  const { settings } = useSettingsContext();

  return (
    <Fragment>
      <VerticalSpacer custom={14} />
      <Section>
        <Title>{label}</Title>
        <TextWrapper>
          <IdentifierText>{settings.controllerId}</IdentifierText>
          <Button
            aria-label={settings.ui.ariaLabels.copyControllerId}
            data-testid="uc-controller-item-button"
            title="Copy"
            onClick={(): void => {
              navigator.clipboard.writeText(settings.controllerId);
            }}
          >
            <CopyIcon />
          </Button>
        </TextWrapper>
      </Section>
    </Fragment>
  );
});

export default ControllerIdItem;
